import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1E3A8A', // 深蓝色，代表专业和信任
      light: '#2563EB',
      dark: '#1E40AF',
    },
    secondary: {
      main: '#047857', // 深绿色，代表增长和利润
      light: '#059669',
      dark: '#065F46',
    },
    background: {
      default: '#F8FAFC', // 浅灰蓝色背景
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1E293B', // 深色文本
      secondary: '#475569', // 次要文本
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      color: '#1E293B',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      color: '#1E293B',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      color: '#1E293B',
    },
    body1: {
      fontSize: '1rem',
      color: '#475569',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
  },
});

export default theme;
